<template>
    <div></div>
</template>

<script>
export default {
    beforeCreate(){
        console.log({ query: this.$route.query });
        parent?.window?.authComplete?.(this.$route.query);
        opener?.window?.authComplete?.(this.$route.query);
        window.close();
    }
}
</script>